import View from "./View.js";
import previewView from "./previewView.js";

class ResultsView extends View {
	_parentElement = document.querySelector(".results");
	_errorMessage = "No recipes found for your query... Please try again.";
	_message = "";

	
	_generateMarkup() {
		// The data we get is an array of recipes.
		return this._data.map(result => previewView.render(result, false)).join("");
	};
}

export default new ResultsView();